import React from 'react';
import { Row, Col } from 'react-bootstrap';
import CreateDeliveryEmptyState from 'src/Images/icons/vehicle-tracking/create-delivery-empty-state.svg';
import 'src/style/createVehicleTracking.css';
import { ReactComponent as Delete } from 'src/Images/icons/common/delete.svg';
import { useSelector } from 'react-redux';

function OutwardVehicleTrackingSelectedDocumentsSection({
  selectedDeliveryOrder,
  errorField,
  handleDeleteDeliveryOrder,
  titlePrefix = null,
}) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;

  return (
    <div
      className={`vehicle-tracking-theme-scrollable-container-${themeColor} scrollable-container col-container`}
    >
      <div className="container-card-shadow border-radius-4 container-padding-5">
        <div className="container-padding-10">
          <div className="selected-documents-title-row">
            {titlePrefix}
            <span className="text-xxl text-bold">Selected Documents</span>
          </div>
          {errorField?.selectedDelivery && (
            <div>
              <p className="text-red text-sm">
                Please attach delivery to proceed
              </p>
            </div>
          )}
          {selectedDeliveryOrder?.length > 0 &&
            selectedDeliveryOrder?.map((deliveryObj) => (
              <Row key={deliveryObj.delivery_id}>
                <Col
                  xxl={12}
                  xl={12}
                  lg={12}
                  md={12}
                  className="form-input-container margin-top-10"
                >
                  <div className="div-flex-row">
                    <div className="div-flex-column">
                      <div className="div-flex-row cg-5">
                        <span className="text-md text-bold">
                          Document Number: {deliveryObj.sap_code}
                        </span>
                      </div>
                    </div>
                    <div className="div-flex-row div-flex-end">
                      <Delete
                        className="icon-size-lg cursor-pointer"
                        onClick={() =>
                          handleDeleteDeliveryOrder(deliveryObj.delivery_id)
                        }
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            ))}
          {selectedDeliveryOrder?.length === 0 ? (
            <div className="div-flex-column cg-20 margin-top-10">
              <div className="document-empty-state-container">
                <img
                  src={CreateDeliveryEmptyState}
                  alt="No PO selected"
                  style={{
                    maxWidth: '100%',
                    width: '120px',
                    height: 'auto',
                  }}
                />
                <div className="margin-top-10">
                  <span className="text-xxl text-bold">
                    No Delivery Selected Yet
                  </span>
                </div>
                <div>
                  <span className="text-md text-grey">
                    Once you find the correct delivery for, <br /> the vehicle,
                    select them to add to this <br /> vehicle entry.
                  </span>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default OutwardVehicleTrackingSelectedDocumentsSection;
